export default __webpack_public_path__ + "static/media/honeycomb.bbad0bcd.svg";